import axios from "axios";
import { getAuthToken, getBaseUri } from "../util/CommonUtil";
//import { useAuthentication } from "../providers/AuthenticationProvider";
import { useEffect, useState } from "react";
import { RESPONSE_STATUS_CODE } from "../constants/Constants";
import { useApp } from "../AppProvider";




export const axiosHttp = axios.create({
    baseURL: getBaseUri(),
});
axiosHttp.interceptors.request.use(function (config) {
    let authToken = getAuthToken();
    if (authToken) {
        config.headers['tovform-access-token'] = authToken;
    }
    return config;
});



const ResponseHandler = ({ children }) => {
    const {showError} = useApp();

    const [isSet, setIsSet] = useState(false);
    //const {login} = useAuthentication();

    useEffect(() => {
        const responseInterceptor = axiosHttp.interceptors.response.use(response => {
            return response

        }, (error) => {
            if (error.status === RESPONSE_STATUS_CODE.FORBIDDEN) {
                // login();
            } else {
                showError();
            }
            return Promise.reject(error)
        })

        setIsSet(true);

        return () => {
            axiosHttp.interceptors.response.eject(responseInterceptor);
        }

    })

    return isSet ? children : null;
}

export default ResponseHandler;

